module.exports = __webpack_public_path__ + "assets/img/dahuojian-13cf4cd2.png";